import { getCard } from "../../content/lookups.js";
import type { ActiveCase } from "../../domain/types/index.js";

export function fieldJudgmentNotice(active: ActiveCase): string | null {
  const result = active.lastFieldJudgment;
  if (!result) return null;
  const name = getCard(result.cardId)?.name ?? result.cardId;
  if (result.result === "used-action") return `「${name}」を公開し、行動を消費せず使用した。`;
  if (result.result === "returned-action") return `「${name}」を公開し、山札の上へ戻した。`;
  if (result.result === "returned-task") return `「${name}」を公開した。対応事項のため、山札の上へ戻した。`;
  return `「${name}」を公開した。労働者のため、山札の上へ戻した。`;
}
